<template>
  <div class="block">
    <!-- 活動名稱 -->
    <label class="form-item d-flex pt-5">
      <div class="w-240px mr-5">
        <h4>活動名稱</h4>
      </div>
      <div class="flex-grow-1 flex-basis-0 my-n2">
        <v-text-field
          v-model="shareholderEvent.title"
          placeholder="請輸入活動名稱"
          outlined
          dense
        ></v-text-field>
      </div>
    </label>
    <!-- 設定活動時間 -->
    <div class="form-item d-flex pt-5">
      <div class="w-240px mr-5">
        <h4>設定活動時間</h4>
      </div>
      <div class="flex-grow-1 flex-basis-0 my-n2 d-flex">
        <v-menu
          v-model="dateMenu"
          :close-on-content-click="false"
          :nudge-right="40"
          transition="scale-transition"
          offset-y
          min-width="290px"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
              v-model="shareholderEvent.event_date"
              placeholder="請選擇日期"
              outlined
              dense
              readonly
              v-bind="attrs"
              v-on="on"
            ></v-text-field>
          </template>
          <v-date-picker
            v-model="shareholderEvent.event_date"
            @input="dateMenu = false"
          ></v-date-picker>
        </v-menu>
      </div>
    </div>
    <!-- 地址 -->
    <div class="form-item d-flex pt-5">
      <div class="w-240px mr-5">
        <h4>地址</h4>
      </div>
      <div class="flex-grow-1 flex-basis-0">
        <v-radio-group v-model="locationType">
          <v-radio
            value="default"
            color="brand-600"
            class="h-20px mr-5 mb-10px"
          >
            <template v-slot:label>
              <div class="h5 ink-01-emphasis--text d-flex align-center">
                使用預設：新北市中和區連城路258號2樓
              </div>
            </template>
          </v-radio>
          <v-radio value="custom" color="brand-600" class="h-20px">
            <template v-slot:label>
              <div class="h5 ink-01-emphasis--text d-flex align-center">
                自訂
              </div>
            </template>
          </v-radio>
          <div class="pl-7" v-if="locationType === 'custom'">
            <v-text-field
              v-model="shareholderEvent.address"
              placeholder="請輸入地址"
              outlined
              dense
            ></v-text-field>
          </div>
        </v-radio-group>
      </div>
    </div>
    <!-- 設定活動時間 -->
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  data: () => ({
    dateMenu: false,
    locationType: 'custom',
    locationDefault: '新北市中和區連城路258號2樓',
  }),
  watch: {
    shareholderEvent() {
      this.locationType = !this.shareholderEvent.address ? 'default' : 'custom';
    },
    locationType(val) {
      this.shareholderEvent.address = val === 'default' ? this.locationDefault : '';
    },
  },
  computed: {
    ...mapState('shareholderEvent', ['shareholderEvent']),
  },
};
</script>

<style></style>
